import React from 'react';
import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';

type ValuesProps = {
  text?: string;
  isChecked: boolean;
};

export const TableCheckBox = ({ isChecked, text }: ValuesProps, rowsInfo: any) => {
  let { onChange, rowData } = rowsInfo;
  const onChangeHandler = (value: boolean) => {
    rowData = { ...rowData, checkBox: { ...rowData.checkBox, isChecked: value } };
    onChange?.(value, { ...rowsInfo, rowData });
  };
  return (
    <Checkbox checked={isChecked} onChange={onChangeHandler}>
      {text}
    </Checkbox>
  );
};
